import { NgModule } from '@angular/core';
import { NotificationDropdownComponent } from './components/notification-dropdown/notification-dropdown.component';
import { CommonModule } from '@angular/common';
import { EnterOtpComponent } from './components/enter-otp/enter-otp.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [NotificationDropdownComponent, EnterOtpComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [NotificationDropdownComponent],
})
export class SharedModule {}
